module.exports = __webpack_public_path__ + "media/images/frog-8558636722f4ed21851f8fe018d1ba57.png";